import { useState } from 'react'
import useRenderEvent from '@/core/hooks/useRenderEvent'
import threadsService from '@/app-domains/threads/threads.service'
import store from '@/core/store'

export function useFeedViewListener (defaultView = 'normal') {
  const [viewType, setViewType] = useState(store.getState().threads.viewType || defaultView)

  useRenderEvent(['UI:view_feed_change'], (type) => {
    setViewType(type)
    threadsService.setViewType(type)
  })

  return { viewType }
}
